import { action } from "satcheljs";
import type { CommandingViewMode } from "owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions";

type ViewModeChangeReason = "modeChange" | "win32Migration";

export interface OnViewModeChangedActionMessage {
    viewMode: CommandingViewMode;
    writeReason: ViewModeChangeReason;
}
export const onViewModeChanged: (viewMode: CommandingViewMode, writeReason?: ViewModeChangeReason) => OnViewModeChangedActionMessage = action("onViewModeChanged", (viewMode: CommandingViewMode, writeReason: ViewModeChangeReason = "modeChange"): OnViewModeChangedActionMessage => ({
    viewMode,
    writeReason,
}));
